export const IMPORT_LIST_COLUMN = "IMPORT_LIST_COLUMN";